import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';

function ClientNotesSub(props) {
  const navigate = useNavigate();
  const [isMain, setMain] = useState(true);
  const { closePopup, clientRefId } = props;
  const [isDisabled, setDisabled] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const note = {
    clientRefId,
    title: '',
    content: '',
    userRefId: Number(sessionStorage.getItem('userRefId'))
  };

  const DependantSchema = Yup.object().shape({
    title: Yup.string()
      .min(2, 'Title is too Short!')
      .max(30, 'Title is too Long!')
      .required('Title of Notes is required'),
    content: Yup.string()
      .min(2, 'Content is too Short!')
      .max(500, 'Content is too Long!')
      .required('Content is required'),
    clientRefId: Yup.number().required('Client RefId is missing, please restart the note')
  });

  const formik = useFormik({
    initialValues: note,
    enableReinitialize: true,
    validationSchema: DependantSchema,
    onSubmit: (values) => {
      saveClientNote(values);
    }
  });

  useEffect(() => {
    if (clientRefId < 0) {
      closePopup();
    }
    // handleAddNote();
  }, []);

  const saveClientNote = (client) => {
    setDisabled(true);
    // client.userRefId = sessionStorage.getItem('userRefId');
    const jsonClient = [];
    jsonClient.push(client);
    console.log('client note', JSON.stringify(jsonClient[0]));
    fetch(
      `${baseUrl}/api/client/AddClientNote?clientRefId=${client.clientRefId}&title=${client.title}&content=${client.content}&userRefId=${client.userRefId}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          notifyPopup(`Client Note Saved Successfully!`, 'success');
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving Client Note!: ${error}`, 'error');
        }
      );
  };

  const handleAddNote = () => {
    note.title = '';
    note.content = '';
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Controls.Input name="clientRefId" label="Member #" disabled />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Controls.Input name="title" label="Note Title (Max 30 Charecters)" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.Input name="content" label="Content of Note" multiline rows={3} />
          </Grid>

          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="outlined"
                disabled={isDisabled}
                startIcon={<SaveIcon />}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}

export default ClientNotesSub;
